import { render } from "./BancontactPayment_Import.vue?vue&type=template&id=27ee3a3c"
import script from "./BancontactPayment_Import.vue?vue&type=script&lang=js"
export * from "./BancontactPayment_Import.vue?vue&type=script&lang=js"

import "./BancontactPayment_Import.vue?vue&type=style&index=0&id=27ee3a3c&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__